import { ILayoutConfig, IRefLayouts, IToolbar } from "@itm/types";
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

type GlobalState = {
    LayoutConfig: ILayoutConfig;
    RefLayouts: IRefLayouts[];
    editTitle: string;
    toolbarOverride: IToolbar | undefined;
    formOpenMode: string | undefined;
};

const initialFormState: GlobalState = {
    LayoutConfig: undefined,
    RefLayouts: [],
    editTitle: '',
    toolbarOverride: undefined,
    formOpenMode: undefined,
};

export const GlobalStore = signalStore(
    { providedIn: 'root' },
    withState(initialFormState),
    withMethods((store) => ({
        setRefLayoutKeys(refLayout: any): void {
            patchState(store, (state) => ({ RefLayouts: refLayout }));
        },
        setEditTitle(editTitle: string): void {
            patchState(store, (state) => ({ editTitle: editTitle }));
        },
        setLayoutProps(props: any): void {
            patchState(store, (state) => ({ LayoutConfig: props }));
        },
        setToolbarOverride(toolbar: IToolbar): void {
            patchState(store, (state) => ({ toolbarOverride: toolbar }));
        },
        setFormOpenMode(mode: string): void {
            patchState(store, (state) => ({ formOpenMode: mode }));
        },
    }))
);
